import React from "react";
import EngagementVideoPage from "../../ui/EngagementVideoPage";

const CupofKindness = () => (
  <EngagementVideoPage
    title="Cup of Kindness"
    videoUrl="https://www.youtube.com/embed/-3fUNnLb7WU"
    videoTitle="Cup of Kindness"
  >
    <p>
      Lockdown 1.0 made each one of us realise the importance of house essentials such as utilities, toiletries & groceries including the hero of the &apos;Cup of Kindness&apos; project- the humble TEA. So, while Team KU was already involved in the project Go Bananas...
    </p>
    <p>
      We thought it would be extremely unkind to deprive the have-nots, of one of life&apos;s simplest and purest pleasures- the joy of drinking a cup of tea!
    </p>
    <p>
      Hence, to bring the magic of tea back to them, Kindness Unlimited with the support of Society Tea and our execution partner Make a Difference, carried out a tea distribution drive through 12 remote villages in Maharashtra. We did this to flag off World Kindness Week 2019.
      <br />
      In fact, our campaign #CupofKindness encouraged others to share their own acts of kindness which they pledged to take up by dropping a small note about it in their own little cups at home.
    </p>
  </EngagementVideoPage>
);

export default CupofKindness;
